/**
 * createRiderTaxRateService
 * @param dataWrapper {ReturnType<import('core/data/data-wrapper')._DB>}
 * @param insuredOccupationService {ReturnType<import('core/service/insured/occupation').createInsuredOccupationService>}
 * @param riderService {Awaited<ReturnType<import('core/service/rider/rider').createRiderService>>}
 */
export function createRiderTaxRateService(dataWrapper, insuredOccupationService, riderService) {
  const _getRiderTaxRates = (gender, age, availableRiders, riderTaxRatesPayload, occupationFactor) => {
    return availableRiders.map((rider) => {
      let riderTaxRates
      const planCode = rider.selectedPlan ? rider.selectedPlan.planCode : ''

      for (let riderTaxRate of riderTaxRatesPayload) {
        if ([rider.code, planCode].includes(riderTaxRate.riderCode)) {
          riderTaxRates = riderTaxRate
        }
      }

      if (!riderTaxRates)
        return {
          code: rider.code,
          TaxRate: {
            retire: 0,
            life: 0,
            health: 0,
          },
        }
      const queryDependencies = {
        selectedRiderPlanCode: planCode,
        gender: gender,
        age: age,
        occupationFactor: occupationFactor[rider.code],
      }

      const taxRate = riderService.queryTaxRate(rider, riderTaxRates, queryDependencies)

      return { code: rider.code, taxRate: taxRate }
    })
  }

  const getRiderTaxRates = async (gender, age, availableRiders, natureOfDuties, displayProductQuery) => {
    const riderTaxRatesPayload = await dataWrapper.getRiderTaxRates()
    const occupationFactor = await insuredOccupationService.getRiskiestOccupationFactorForRiders(
      displayProductQuery,
      natureOfDuties,
      availableRiders
    )
    return _getRiderTaxRates(gender, age, availableRiders, riderTaxRatesPayload, occupationFactor)
  }

  return {
    _getRiderTaxRates,
    getRiderTaxRates,
  }
}
